import { ChangeDetectionStrategy, Component, input, output, signal, WritableSignal } from '@angular/core';
import { form, FormField } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { STRIPE_TRANSACTION_STATUSES, TransactionAdminFilterKey, ZoudashUtils } from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  DataHeaderFilter,
  FilterChangedDetection,
  FilterRecord,
} from '@workspace/ng-aura';
import { TransactionStatusDisplayPipe } from '@workspace/ng-data-access';
import { TransactionColumnKey } from '../abstract-transactions-data-table.component';

export interface TransactionFilterModel {
  status: string | string[] | null;
}

@Component({
  selector: 'core-transactions-data-table-filter',
  templateUrl: './transactions-data-table-filter.component.html',
  imports: [
    FormField,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    TransactionStatusDisplayPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionsDataTableFilterCoreComponent extends AbstractSignalFormComponent<
  Partial<Record<TransactionAdminFilterKey, string | string[]>>,
  TransactionFilterModel
> {
  filterChanged = output<FilterChangedDetection>();
  currentFilterView = input<string | null>(null);
  filters = input.required<DataHeaderFilter<TransactionColumnKey>[]>();
  transactionStatusValues = STRIPE_TRANSACTION_STATUSES;
  transactionAdminFilterKey = TransactionAdminFilterKey;

  override model: WritableSignal<TransactionFilterModel> = signal<TransactionFilterModel>({
    status: null,
  });

  override formTree = form(this.model);

  override emitDto(newDto: Partial<Record<TransactionAdminFilterKey, string | string[]>>): void {
    this.filterChanged.emit({
      filter: newDto as FilterRecord,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(
    dto: Partial<Record<TransactionAdminFilterKey, string | string[]>>,
  ): TransactionFilterModel {
    return {
      status: dto?.[TransactionAdminFilterKey.Status] ?? null,
    };
  }

  protected override buildDtoFromModel(
    model: TransactionFilterModel,
  ): Partial<Record<TransactionAdminFilterKey, string | string[]>> {
    const dto: Partial<Record<TransactionAdminFilterKey, string | string[]>> = {
      status: model.status ?? undefined,
    };
    return Object.fromEntries(Object.entries(dto).filter(([_, v]) => v != null)) as Partial<
      Record<TransactionAdminFilterKey, string | string[]>
    >;
  }
}
